/* eslint-disable react/jsx-no-bind */
import { Info as InfoIcon } from '@mui/icons-material';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Pagination,
} from '@mui/material';
import React, { useState } from 'react';

const RideList = () => {
  // Sample data
  const rides = [
    {
      id: 1,
      rideNo: '1082605202208091',
      customerName: 'Raj Patel',
      driverName: 'Teat',
      vehicle: 'SUV',
      cost: '$569.68',
      status: 'completed',
    },
    {
      id: 2,
      rideNo: '5282105202208099',
      customerName: 'User Prashant',
      driverName: 'Driver Prashant',
      vehicle: 'SUV',
      cost: '$458.35',
      status: 'completed',
    },
    {
      id: 3,
      rideNo: '5282105202208099',
      customerName: 'User Prashant',
      driverName: 'Driver Prashant',
      vehicle: 'SUV',
      cost: '$458.35',
      status: 'completed',
    },
    {
      id: 4,
      rideNo: '5282105202208099',
      customerName: 'User Prashant',
      driverName: 'Driver Prashant',
      vehicle: 'SUV',
      cost: '$458.35',
      status: 'completed',
    },
    {
      id: 5,
      rideNo: '5282105202208099',
      customerName: 'User Prashant',
      driverName: 'Driver Prashant',
      vehicle: 'SUV',
      cost: '$458.35',
      status: 'completed',
    },

    {
      id: 6,
      rideNo: '5282105202208099',
      customerName: 'User Prashant',
      driverName: 'Driver Prashant',
      vehicle: 'SUV',
      cost: '$458.35',
      status: 'completed',
    },
    {
      id: 7,
      rideNo: '5282105202208099',
      customerName: 'User Prashant',
      driverName: 'Driver Prashant',
      vehicle: 'SUV',
      cost: '$458.35',
      status: 'completed',
    },
    {
      id: 8,
      rideNo: '5282105202208099',
      customerName: 'User Prashant',
      driverName: 'Driver Prashant',
      vehicle: 'SUV',
      cost: '$458.35',
      status: 'completed',
    },
    {
      id: 9,
      rideNo: '5282105202208099',
      customerName: 'User Prashant',
      driverName: 'Driver Prashant',
      vehicle: 'SUV',
      cost: '$458.35',
      status: 'completed',
    },
    {
      id: 10,
      rideNo: '5282105202208099',
      customerName: 'User Prashant',
      driverName: 'Driver Prashant',
      vehicle: 'SUV',
      cost: '$458.35',
      status: 'completed',
    },
    {
      id: 11,
      rideNo: '5282105202208099',
      customerName: 'User Prashant',
      driverName: 'Driver Prashant',
      vehicle: 'SUV',
      cost: '$458.35',
      status: 'completed',
    },
    {
      id: 12,
      rideNo: '5282105202208099',
      customerName: 'User Prashant',
      driverName: 'Driver Prashant',
      vehicle: 'SUV',
      cost: '$458.35',
      status: 'completed',
    },
    {
      id: 13,
      rideNo: '5282105202208099',
      customerName: 'User Prashant',
      driverName: 'Driver Prashant',
      vehicle: 'SUV',
      cost: '$458.35',
      status: 'completed',
    },
    // Add more data as needed...
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Calculate the data for the current page
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentRides = rides.slice(startIndex, endIndex);

  // Calculate total pages
  const totalPages = Math.ceil(rides.length / itemsPerPage);

  // Handle page change
  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        All Ride List of Taxi Ride
      </Typography>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>No</TableCell>
              <TableCell>Ride No.</TableCell>
              <TableCell>Customer Name</TableCell>
              <TableCell>Driver Name</TableCell>
              <TableCell>Vehicle Type</TableCell>
              <TableCell>Total Cost</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentRides.map((ride, index) => (
              <TableRow key={ride.id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{ride.rideNo}</TableCell>
                <TableCell>{ride.customerName}</TableCell>
                <TableCell>{ride.driverName}</TableCell>
                <TableCell>{ride.vehicle}</TableCell>
                <TableCell>{ride.cost}</TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    size="small"
                    style={{
                      backgroundColor:
                        ride.status === 'completed' ? '#4caf50' : '#f44336',
                      color: '#fff',
                      textTransform: 'capitalize',
                    }}
                  >
                    {ride.status}
                  </Button>
                </TableCell>
                <TableCell>
                  <InfoIcon style={{ cursor: 'pointer', color: '#1976d2' }} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box display="flex" justifyContent="flex-end" mt={2}>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
        />
      </Box>
    </Box>
  );
};

export default RideList;
